import { useStore } from "@tanstack/react-store";
import Hammer from "hammerjs";
import { useEffect, useEffectEvent } from "react";

import { useGlobal } from "../lib/global-context";
import {
	cameraControlsActionStore,
	focusedPillarIndexStore,
	hoverPillarSlugStore,
	routeStore,
} from "../lib/store";
import type { VoidComponent } from "../lib/types";

const MobileIslandSwipe: VoidComponent = () => {
	const { pillars } = useGlobal();
	const { level } = useStore(routeStore);

	const navigateToIndexEvent = useEffectEvent((newIndex: number) => {
		const totalPillars = pillars.length;
		const wrappedIndex = ((newIndex % totalPillars) + totalPillars) % totalPillars;
		const pillar = pillars[wrappedIndex];

		if (pillar) {
			focusedPillarIndexStore.setState(wrappedIndex);
			hoverPillarSlugStore.setState(pillar.slug.current);
		}
	});

	useEffect(() => {
		if (level !== "index") {
			return (): void => {
				//
			};
		}

		const hammer = new Hammer(document.body, {
			touchAction: "auto",
			inputClass: Hammer.TouchMouseInput,
		});

		hammer.get("swipe").set({ direction: Hammer.DIRECTION_VERTICAL });
		hammer.get("pan").set({ direction: Hammer.DIRECTION_VERTICAL, threshold: 10 });

		let panEndTimeout: ReturnType<typeof setTimeout> | null = null;

		const onPanStart = (): void => {
			cameraControlsActionStore.setState(true);
		};

		const onPanEnd = (): void => {
			panEndTimeout = setTimeout(() => {
				cameraControlsActionStore.setState(false);
			}, 100);
		};

		const onSwipeUp = (): void => {
			navigateToIndexEvent(focusedPillarIndexStore.state + 1);
		};

		const onSwipeDown = (): void => {
			navigateToIndexEvent(focusedPillarIndexStore.state - 1);
		};

		hammer.on("panstart", onPanStart);
		hammer.on("panend", onPanEnd);
		hammer.on("swipeup", onSwipeUp);
		hammer.on("swipedown", onSwipeDown);

		return (): void => {
			if (panEndTimeout !== null) {
				clearTimeout(panEndTimeout);
			}

			hammer.off("panstart", onPanStart);
			hammer.off("panend", onPanEnd);
			hammer.off("swipeup", onSwipeUp);
			hammer.off("swipedown", onSwipeDown);
			hammer.destroy();
		};
	}, [level]);

	return null;
};

export { MobileIslandSwipe };
